import { html } from "lit-html";
import { DynamicSettings } from "./DynamicSettings";
import { useSaveDynamicSettings } from "./useSaveDynamicSettings";
import { COUNTRY_MAP } from "Services/constants";

export interface Props {
	newSettings: DynamicSettings;
	setNewSettings: (settings: DynamicSettings) => void;
}

export const useDefaultSuperPromoCodeSection = (props: Props) => {
	const saver = useSaveDynamicSettings({ newSettings: props.newSettings });

	const handleInput = (value: string, cultureCode: string) => {
		const promoCode = value.trim().toUpperCase() || "";

		const oldSetting = props.newSettings.DefaultSuperPromoCodeSettings?.find(
			(setting) => setting.Culture.toLowerCase() === cultureCode.toLowerCase()
		);

		const newSuperPromoCodeSettings = oldSetting
			? props.newSettings.DefaultSuperPromoCodeSettings?.map((setting) =>
					setting.Culture.toLowerCase() === oldSetting.Culture.toLowerCase()
						? { ...oldSetting, Code: promoCode }
						: setting
			  )
			: [...props.newSettings.DefaultSuperPromoCodeSettings, { Culture: cultureCode, Code: promoCode }];

		props.setNewSettings({
			...props.newSettings,
			DefaultSuperPromoCodeSettings: newSuperPromoCodeSettings,
		});
	};

	const inputTemplate = (cultureCode: string) => {
		const label = `Default Super Promo Code ${cultureCode.split("-")[1].toUpperCase()}`;
		const value =
			props.newSettings.DefaultSuperPromoCodeSettings?.find(
				(s) => s.Culture.toLowerCase() === cultureCode.toLowerCase()
			)?.Code || "";

		return html`
			<ac-input
				.label=${label}
				.value=${value}
				.onInput=${(newValue: string) => handleInput(newValue, cultureCode)}
			></ac-input>
		`;
	};

	const htmlTemplate = () => html`
		<section class="mt-5 max-w-[640px]">
			<div class="grid grid-cols-2 gap-4">
				${Array.from(COUNTRY_MAP.keys()).map((cultureCode) => inputTemplate(cultureCode))}
			</div>
			${saver.htmlTemplate()}
		</section>
	`;

	return { htmlTemplate };
};
